import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '@ln/common-ui-icon';
import { Text } from '@ln/common-ui-text';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function Carditem(_a) {
    var { variant = 'default', icon, rightIcon, description, badge = undefined, content, className, type = 'button', active } = _a, r = __rest(_a, ["variant", "icon", "rightIcon", "description", "badge", "content", "className", "type", "active"]);
    const carditemColors = {
        default: 'text-neutral-light-800 text-blue-500_hover bg-blue-500-16_hover',
        highlight: 'bg-neutral-light-50 text-neutral-light-800 bg-neutral-light-800_hover',
        digital: 'bg-neutral-light-800 text-neutral-light-50 bg-neutral-black_hover',
        danger: 'text-danger-500 bg-danger-500-16 bg-danger-500-16_hover',
    };
    const _className = classNames('flex ai-center text-start gap-8 w-100 p-16 transition-regular rounded-4 card-item', active ? 'border border-left border-4 border-blue-500 text-blue-500 cursor-initial' : carditemColors[variant], className);
    // Set element to render as component
    const Component = {
        link: 'a',
        button: 'button',
    }[type];
    return (
    // @ts-expect-error: Allow component to be rendered as button, anchor
    jsxs(Component, Object.assign({ className: _className }, r, { "data-variant": variant }, { children: [icon && (jsx("div", Object.assign({ className: 'flex ai-center jc-center p-8 rounded-circle icon-left-container transition-regular' }, { children: jsx(Icon, Object.assign({ color: 'inherit', size: 16 }, { children: icon })) }))), jsxs("div", Object.assign({ className: 'flex flex-column flex-grow-1 gap-4' }, { children: [jsx(Text, Object.assign({ className: 'text-16' }, { children: content })), description && jsx(Text, Object.assign({ className: 'text-12 text-neutral-light-600' }, { children: description }))] })), badge && jsx("span", Object.assign({ className: 'bg-blue-500' }, { children: badge })), rightIcon && (jsx(Icon, Object.assign({ color: 'inherit', size: 24 }, { children: rightIcon })))] })));
}

export { Carditem };
